import React, { useMemo } from 'react';

import { Reconnect } from 'src/federation/Reconnect';

import {
  getChannelSalesReportTableProps,
  ChannelSalesReportTableProps,
} from './channelSalesReportTableProps';

export const ReportTable = ({
  venueId,
  fromDate,
  toDate,
  reportData,
}: ChannelSalesReportTableProps) => {
  const props = useMemo(
    () => getChannelSalesReportTableProps({ venueId, fromDate, toDate, reportData }),
    [venueId, fromDate, toDate, reportData],
  );

  return <Reconnect name="ReportTable" props={props} />;
};
